// extracted by mini-css-extract-plugin
export default {"touchable":"touchable_touchable__QhfS-","ripple":"touchable_ripple__VDWu8","rippleAnim":"touchable_rippleAnim__wmFXk"};